
export const cle_COURTJUS = '$A8rJ&ym0*gWc60qmWL!%jRefColT9';

export const URL_COURTJUS_BACK = 'https://courtjus.alwaysdata.net';
export const URL_COURTJUS_FRONT = 'https://biasses.court-jus.fr';
export const URL_IMG_UPLOAD = 'https://courtjus.alwaysdata.net/upload';

// export const URL_COURTJUS_BACK = 'http://localhost:8080';
// export const URL_COURTJUS_FRONT = 'http://localhost:3000';
// export const URL_IMG_UPLOAD = 'http://localhost:8080/upload';

